import { queryClient } from "./client"

export const AUTH_KEY = [`auth`]
export const USER_KEY = [`user`]

export const COMPANY_BASE_KEY = [`company`]
export const WORKSPACE_KEY = [`workspace`]
export const OPEX_BASE_KEY = [`opex`]
export const SETTINGS_KEY = [`global-settings`]
export const COGS_BASE_KEY = [`cogs`]
export const REVENUES_BASE_KEY = [`revenues`]
export const PERSONNEL_BASE_KEY = [`personnel`]
export const FINANCIAL_MODEL_BASE_KEY = [`financial-model`]
export const FINANCIAL_MODEL_SETTINGS_BASE_KEY = [`financial-model-settings`]

export const FINANCIAL_MODEL_GLOBAL_SETTINGS_BASE_KEY = [
  `financial-model-global-settings`,
]

export const REPORT_BASE_KEY = [`report`]

export const FINANCIAL_TABLES_BASE_KEY = [`financial-tables`]

export const FUNDRAISING_ADVISORY_BASE_KEY = [`fundraising-advisory`]

export const TOTALS_KEY = [`totals`]

export const OIC_KEY = [`oic`]

export const EXPORT = [`export`]

export const TWC_BASE_KEY = COGS_BASE_KEY.concat([`twc`])

export const FIXED_ASSETS_BASE_KEY = [`fixed-assets`] as const

export const VAT_BASE_KEY = [`vat`] as const

export const PROVISIONS_BASE_KEY = [`provisions`] as const

export const CORPORATE_TAXES_BASE_KEY = [`corporate-taxes`]

export const OWC_BASE_KEY = [`owc`] as const

export const CAPITAL_STRUCTURE_BASE_KEY = [`capital-structure`] as const

type BaseQueryKey = typeof AUTH_KEY | typeof USER_KEY | typeof WORKSPACE_KEY
type OpexQueryKey = typeof OPEX_BASE_KEY
type CogsQueryKey = typeof COGS_BASE_KEY
type RevenuesQueryKey = typeof REVENUES_BASE_KEY
type PersonnelQueryKey = typeof PERSONNEL_BASE_KEY
type FinancialModelQueryKey = typeof FINANCIAL_MODEL_BASE_KEY
type FinancialModelSettingsQueryKey = typeof FINANCIAL_MODEL_SETTINGS_BASE_KEY
type CorporateTaxesQueryKey = typeof CORPORATE_TAXES_BASE_KEY

type OicQueryKey = typeof OIC_KEY

type ExportQueryKey = typeof EXPORT

type TotalsQueryKey = typeof TOTALS_KEY

type SettingsQueryKey = typeof SETTINGS_KEY

type TWCQueryKey = typeof TWC_BASE_KEY

type FixedAssetsQueryKey = typeof FIXED_ASSETS_BASE_KEY

type VatQueryKey = typeof VAT_BASE_KEY

type ProvisionsQueryKey = typeof PROVISIONS_BASE_KEY

type OWCQueryKey = typeof OWC_BASE_KEY

type CapitalStructureQueryKey = typeof CAPITAL_STRUCTURE_BASE_KEY

export type QueryKey =
  | BaseQueryKey
  | OpexQueryKey
  | CogsQueryKey
  | RevenuesQueryKey
  | PersonnelQueryKey
  | FinancialModelQueryKey
  | FinancialModelSettingsQueryKey
  | OicQueryKey
  | TotalsQueryKey
  | ExportQueryKey
  | SettingsQueryKey
  | TWCQueryKey
  | FixedAssetsQueryKey
  | VatQueryKey
  | CorporateTaxesQueryKey
  | ProvisionsQueryKey
  | OWCQueryKey
  | CapitalStructureQueryKey
export const createQueryKey = ({
  baseKey,
  keys,
}: {
  baseKey: QueryKey
  keys: (string | number | undefined)[]
}) => [...baseKey, ...keys].filter(Boolean)

export const invalidateGlobalsQueryKey = (queryKeys: QueryKey[]) => {
  queryKeys.forEach((queryKey) => {
    queryClient.invalidateQueries({ queryKey })
  })
}

export const resetGlobalQueryKey = (queryKeys: QueryKey[]) => {
  queryKeys.forEach((queryKey) => {
    queryClient.resetQueries({ queryKey })
  })
}
